export default __webpack_public_path__ + "media/zurb/img/icons/favicon/apple-touch-icon-57x57-cb1add3424e6562ea8b6c93efd7478fe.png";